import type { IDisplayService } from '../services/displayService';
import type { IValidationService } from '../services/validationService';
import type { Section } from './Section';
import type { Group } from './Group';
import type { Question } from './Question';

export class Step {
  public id: string = '';
  public label: string = '';
  public title: string = '';
  public navigationLabel: string = '';
  public sections: Section[] = [];

  public isValid(displayService: IDisplayService, validationService: IValidationService): boolean {
    let valid = true;

    this.sections.forEach((section: Section) => {
      if (!displayService.showSection(section)) {
        return;
      }

      section.groups.forEach((group: Group) => {
        if (!displayService.showGroup(group)) {
          return;
        }

        group.questions.forEach((question: Question) => {
          if (question.isDisplayOnly()) {
            return;
          }
          if (displayService.showQuestion(question, group) && !validationService.validate(question, group).valid) {
            valid = false;
          }
        });
      });
    });

    return valid;
  }

  public isComplete(displayService: IDisplayService): boolean {
    let complete = true;

    this.sections.forEach((section: Section) => {
      if (!displayService.showSection(section)) {
        return;
      }

      section.groups.forEach((group: Group) => {
        if (!displayService.showGroup(group)) {
          return;
        }

        group.questions.forEach((question: Question) => {
          if (question.isDisplayOnly()) {
            return;
          }
          if (displayService.showQuestion(question, group) && !question.optional && !question.hasAnswered()) {
            complete = false;
          }
        });
      });
    });

    return complete;
  }

  public hasViewableQuestions(displayService: IDisplayService): boolean {
    let toShow = false;

    this.sections.forEach((section: Section) => {
      if (!displayService.showSection(section)) {
        return;
      }

      section.groups.forEach((group: Group) => {
        if (!displayService.showGroup(group)) {
          return;
        }

        group.questions.forEach((question: Question) => {
          if (displayService.showQuestion(question, group)) {
            toShow = true;
          }
        });
      });
    });

    return toShow;
  }
}
